import React, {
    useEffect, useState, useRef,
} from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
// import { User } from '@phosphor-icons/react';
import { useHistory } from 'react-router-dom';
import Button from '../../../common/button/Button';
import ProfileImage from '../../../common/ProfileImage/ProfileImage';
import MenuProfile from '../../menuBar/components/MenuProfile';

const ProfileIcon = ({ user, fetchingProfile, isLoggedIn, isOpen, setProfileModalState, logout }) => {
    const [isMounted, setIsMounted] = useState(false);
    const [openMenuProfile, setOpenMenuProfile] = useState(false);
    const [shouldRedirect, setShouldRedirect] = useState(false);

    const menuRef = useRef();
    const history = useHistory();

    useEffect(() => {
        if (shouldRedirect) {
            setOpenMenuProfile(false);

            setShouldRedirect(false);

            history.push('/perfil/editar-perfil');
        }
    }, [openMenuProfile, shouldRedirect, history]);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setOpenMenuProfile(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    if (!isMounted) {
        // default until mounted on the client to avoid warnings when hydrating
        return (
            <div className="profileIcon nav-item">
                <Button className="nav-link" onClick={() => setProfileModalState(!isOpen)} title="Entrar">
                    <span className="text">
                        Login
                    </span>
                </Button>
            </div>
        );
    }

    const buttonTitle = 'Login';
    const isPro = user.isPro && !fetchingProfile;

    const handleLogout = () => {
        logout();

        setOpenMenuProfile(false);
    };

    return (
        <React.Fragment>
            <Button
                title={buttonTitle}
                className={`tw-w-full md:tw-w-auto${isLoggedIn ? ' isLoggedIn' : ''}`}
                onClick={() => {
                    if (isLoggedIn) {
                        setOpenMenuProfile(true);
                    } else {
                        setProfileModalState(true);
                    }
                }}
            >
                {isLoggedIn ? (
                    <ProfileImage name={user.name || '?'} lastName={user.lastName} size={22} isPro={isPro} />
                ) : (
                    <React.Fragment>
                        <div className="tw-flex">
                            <svg width="20" height="21" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M0.22168 8.99997C0.22168 6.77504 1.10553 4.64123 2.6788 3.06796C4.25206 1.49469 6.38587 0.61084 8.61081 0.61084C10.8357 0.61084 12.9696 1.49469 14.5428 3.06796C16.1161 4.64123 16.9999 6.77504 16.9999 8.99997C16.9999 11.2249 16.1161 13.3587 14.5428 14.932C12.9696 16.5053 10.8357 17.3891 8.61081 17.3891C6.38587 17.3891 4.25206 16.5053 2.6788 14.932C1.10553 13.3587 0.22168 11.2249 0.22168 8.99997ZM8.61081 1.81417C7.218 1.81422 5.85523 2.21904 4.68827 2.97939C3.52132 3.73973 2.60048 4.82282 2.03778 6.0969C1.47509 7.37099 1.29479 8.78114 1.51882 10.1558C1.74286 11.5305 2.36156 12.8104 3.29967 13.8399C3.8692 12.9478 4.6544 12.2137 5.5827 11.7054C6.511 11.1971 7.55245 10.931 8.61081 10.9316C9.6692 10.9309 10.7107 11.1969 11.639 11.7053C12.5673 12.2136 13.3525 12.9478 13.9219 13.8399C14.8601 12.8104 15.4788 11.5305 15.7028 10.1558C15.9268 8.78114 15.7465 7.37099 15.1838 6.0969C14.6211 4.82282 13.7003 3.73973 12.5333 2.97939C11.3664 2.21904 10.0036 1.81422 8.61081 1.81417ZM13.0213 14.6734C12.5731 13.9009 11.9297 13.2597 11.1556 12.8142C10.3815 12.3687 9.5039 12.1345 8.61081 12.135C7.71767 12.1345 6.84009 12.3687 6.066 12.8142C5.29191 13.2597 4.64851 13.9009 4.20028 14.6734C5.46031 15.6559 7.01299 16.1883 8.61081 16.1858C10.2727 16.1858 11.8028 15.6208 13.0213 14.6734ZM5.63414 7.73964C5.63414 6.95018 5.94775 6.19305 6.50599 5.63482C7.06422 5.07659 7.82135 4.76297 8.61081 4.76297C9.4003 4.76297 10.1574 5.07659 10.7156 5.63482C11.2739 6.19305 11.5875 6.95018 11.5875 7.73964C11.5875 8.5291 11.2739 9.28623 10.7156 9.8445C10.1574 10.4027 9.4003 10.7163 8.61081 10.7163C7.82135 10.7163 7.06422 10.4027 6.50599 9.8445C5.94775 9.28623 5.63414 8.5291 5.63414 7.73964ZM8.61081 5.96631C8.37793 5.96631 8.14733 6.01218 7.93218 6.10129C7.71703 6.19041 7.52154 6.32103 7.35687 6.4857C7.1922 6.65037 7.06158 6.84586 6.97246 7.06101C6.88334 7.27617 6.83747 7.50676 6.83747 7.73964C6.83747 7.97252 6.88334 8.20311 6.97246 8.41826C7.06158 8.63342 7.1922 8.82891 7.35687 8.99358C7.52154 9.15825 7.71703 9.28887 7.93218 9.37799C8.14733 9.4671 8.37793 9.513 8.61081 9.513C9.08113 9.513 9.5322 9.32614 9.8647 8.99358C10.1973 8.66101 10.3841 8.20996 10.3841 7.73964C10.3841 7.26932 10.1973 6.81827 9.8647 6.4857C9.5322 6.15314 9.08113 5.96631 8.61081 5.96631Z" fill="#1E2024" />
                            </svg>
                            <span className="tw-ml-3 md:tw-ml-0">Login</span>
                        </div>
                    </React.Fragment>
                )}
            </Button>
            {isLoggedIn && openMenuProfile && (
                <MenuProfile
                    logout={handleLogout}
                    setIsOpenMenuProfile={setOpenMenuProfile}
                    isOpenMenuProfile={openMenuProfile}
                    menuRef={menuRef}
                    setShouldRedirect={setShouldRedirect}
                />
            )}
        </React.Fragment>
    );
};

ProfileIcon.propTypes = exact({
    isLoggedIn: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired,
    fetchingProfile: PropTypes.bool,
    setProfileModalState: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    logout: PropTypes.func,
});

export default ProfileIcon;
